import React, { FC } from 'react';
import { useStores } from 'hooks/useStores';
import SearchTab from '../SearchTab';
import TypeOfAdvert from '../TypeOfAdvert';
import GeoSuggest from '../GeoSuggest';
import DateOfAnnouncement from '../DateOfAnnouncement';
import TypeOfTransport from '../TypeOfTransport';

import { Item } from '../SearchTab/SearchTabStyles';

const ProposalsPurchaseTab: FC = () => {
  const {
    findTrucksStore: { countHideFilledFields },
  } = useStores();

  return (
    <SearchTab countHideFilledFields={countHideFilledFields} isShow={false} isProposals>
      <Item className="select-advert-type">
        <TypeOfAdvert />
      </Item>
      <Item className="geo-block">
        <GeoSuggest />
      </Item>

      <Item className="type-block">
        <TypeOfTransport />
      </Item>
    </SearchTab>
  );
};

export default ProposalsPurchaseTab;
